import {
  endOfToday,
  endOfTomorrow,
  endOfYesterday,
  nextSaturday,
  startOfDay,
  startOfToday,
  startOfTomorrow,
  startOfYesterday,
  endOfDay,
  nextSunday,
} from "date-fns";
import { parseDate } from "@/utilities/datetime";

const getDateRangeForTabName = (tab: string) => {
  if (tab === "tomorrow") {
    return [startOfTomorrow(), endOfTomorrow()];
  }

  if (tab === "yesterday") {
    return [startOfYesterday(), endOfYesterday()];
  }

  if (tab === "saturday") {
    const saturday = nextSaturday(startOfToday());
    return [startOfDay(saturday), endOfDay(saturday)];
  }

  if (tab === "sunday") {
    const sunday = nextSunday(startOfToday());
    return [startOfDay(sunday), endOfDay(sunday)];
  }

  // if matches dd-mm-yyyy parse as string
  if (/^\d{4}-\d{2}-\d{2}$/.test(tab)) {
    return getDateRangeForDate(tab);
  }

  return [startOfToday(), endOfToday()];
};

const getDateRangeForDate = (dateString: string) => {
  const date = parseDate(dateString);

  if (!date) return [startOfToday(), endOfToday()];

  return [startOfDay(date), endOfDay(date)];
};

export { getDateRangeForDate, getDateRangeForTabName };
